import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";

import {
  Grid,
  TextField,
  //   FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";

import WeekDaySelector from "../WeekDaySelector";
import MonthDaySelector from "../MonthDaySelector";
import { KeyboardDatePicker } from "@material-ui/pickers";

import moment from "moment";

import { RepeatInterval } from "../../types/enums";

const RepeatSelector = (props) => {
  const { t } = useTranslation();

  const [every, setEvery] = useState(1);
  const [interval, setInterval] = useState(RepeatInterval.DAY);
  const [weekDays, setweekDays] = useState([]);

  const [beginDate, setBeginDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  useEffect(() => {
    props.onChange({
      every,
      interval,
      beginDate,
      endDate,
      weekDays,
    });
  }, [every, interval, beginDate, endDate, weekDays]);

  useEffect(() => {
    console.log("weekDays", weekDays);
  }, [weekDays]);

  //   const onChange = () => {
  //     props.onChange({
  //       every,
  //       interval,
  //       beginDate,
  //       endDate,
  //     });
  //   };

  //   onChange();

  return (
    <Grid container spacing={3}>
      <Grid item xs={2} sm={1}>
        <InputLabel htmlFor="everyNumber">Iedere</InputLabel>
        <TextField
          type="number"
          id="everyNumber"
          name="everyNumber"
          value={every}
          onChange={(e) =>
            e.target.value >= 1 &&
            e.target.value <= 99 &&
            setEvery(e.target.value)
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={4} sm={5}>
        <InputLabel htmlFor="clas">&nbsp;</InputLabel>
        <Select
          id="clas"
          name="clas"
          value={interval}
          onChange={(e) => setInterval(e.target.value)}
          fullWidth
        >
          {/* {Object.values(RepeatInterval).map((value, i) => ( */}
          {["day", "week"].map((value, i) => (
            <MenuItem key={i} value={value}>
              {t(every > 1 ? value + "s" : value)}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={12} sm={6}>
        {interval === RepeatInterval.WEEK && (
          <WeekDaySelector onChange={(weekDays) => setweekDays(weekDays)} />
        )}
        {interval === RepeatInterval.MONTH && <MonthDaySelector />}
      </Grid>
      <Grid item xs={12} sm={6}>
        <KeyboardDatePicker
          clearable
          mask="__-__-____"
          id="beginDate"
          name="beginDate"
          label="Begindatum *"
          value={beginDate}
          format={"L"}
          onChange={(m) => setBeginDate(m)}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <KeyboardDatePicker
          clearable
          mask="__-__-____"
          id="endDate"
          name="endDate"
          label="Einddatum *"
          value={endDate}
          format={"L"}
          onChange={(m) => setEndDate(m)}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

RepeatSelector.propTypes = {
  onChange: PropTypes.function,
};

export default RepeatSelector;



// WEBPACK FOOTER //
// ./src/components/forms/RepeatSelector.js